import { resolveComponent as _resolveComponent, createVNode as _createVNode, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives, vShow as _vShow, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "m-auto px-8 md:px-20 pb-8" }
const _hoisted_2 = { class: "max-w-screen-2xl m-auto" }
const _hoisted_3 = { class: "py-10 flex justify-between items-center" }
const _hoisted_4 = { class: "flex" }
const _hoisted_5 = { class: "pb-6" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "font-bold" }
const _hoisted_8 = {
  key: 1,
  class: "flex items-center justify-between"
}
const _hoisted_9 = { class: "flex flex-col" }
const _hoisted_10 = { class: "font-bold" }
const _hoisted_11 = { class: "font-bold" }
const _hoisted_12 = { class: "font-bold" }
const _hoisted_13 = { class: "font-bold" }
const _hoisted_14 = { class: "grid xl:grid-cols-3 gap-4 pt-6 relative border border-next-gray-md-dark px-3 mb-5" }
const _hoisted_15 = {
  key: 0,
  class: "flex flex-col pb-3 grow"
}
const _hoisted_16 = { class: "relative flex items-center" }
const _hoisted_17 = {
  key: 1,
  class: "flex flex-col pb-3 col-span-2"
}
const _hoisted_18 = {
  key: 2,
  class: "pb-3"
}
const _hoisted_19 = { class: "flex items-end justify-center mb-3" }
const _hoisted_20 = { class: "pt-6 relative border border-next-gray-md-dark px-3 mb-5 pb-3" }
const _hoisted_21 = { class: "grid xl:grid-cols-3 gap-4 pt-6 relative border border-next-gray-md-dark px-3 mb-5 pb-3" }
const _hoisted_22 = { class: "flex flex-col" }
const _hoisted_23 = {
  key: 0,
  class: "flex flex-col"
}
const _hoisted_24 = { class: "flex flex-col" }
const _hoisted_25 = { class: "flex items-start" }
const _hoisted_26 = { class: "grid grid-cols-1 gap-3" }
const _hoisted_27 = { class: "underline text-sm text-next-atp" }
const _hoisted_28 = { class: "underline text-sm text-next-atp mb-1" }
const _hoisted_29 = { class: "grid grid-cols-3 gap-3 mb-3 pt-3" }
const _hoisted_30 = { class: "grow flex" }
const _hoisted_31 = { class: "flex flex-col grow gap-3" }
const _hoisted_32 = { class: "flex flex-col grow justify-end gap-3" }
const _hoisted_33 = ["onClick"]
const _hoisted_34 = ["onClick"]
const _hoisted_35 = ["href"]
const _hoisted_36 = ["href"]
const _hoisted_37 = { class: "flex flex-col mb-5" }
const _hoisted_38 = { class: "flex flex-col mb-5" }
const _hoisted_39 = { class: "flex flex-col gap-3" }
const _hoisted_40 = { class: "grow flex" }
const _hoisted_41 = { class: "flex flex-col grow gap-3" }
const _hoisted_42 = { class: "flex flex-col grow justify-end gap-3" }
const _hoisted_43 = ["onClick"]
const _hoisted_44 = ["onClick"]
const _hoisted_45 = ["href"]
const _hoisted_46 = ["href"]
const _hoisted_47 = { class: "flex flex-col mb-5" }
const _hoisted_48 = { class: "flex flex-col mb-5" }
const _hoisted_49 = { class: "flex flex-col gap-3" }
const _hoisted_50 = { class: "grow flex" }
const _hoisted_51 = { class: "flex flex-col grow gap-3" }
const _hoisted_52 = { class: "flex flex-col grow justify-end gap-3" }
const _hoisted_53 = ["onClick"]
const _hoisted_54 = ["onClick"]
const _hoisted_55 = ["href"]
const _hoisted_56 = ["href"]
const _hoisted_57 = { class: "flex flex-col mb-5" }
const _hoisted_58 = { class: "flex flex-col mb-5" }
const _hoisted_59 = { class: "flex flex-col gap-3" }
const _hoisted_60 = { class: "flex flex-col mb-3" }
const _hoisted_61 = { class: "flex justify-self-start bg-white" }
const _hoisted_62 = { class: "flex justify-end pt-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Loading = _resolveComponent("Loading")!
  const _component_Alert = _resolveComponent("Alert")!
  const _component_Breadcrumbs = _resolveComponent("Breadcrumbs")!
  const _component_NextButton = _resolveComponent("NextButton")!
  const _component_VueMultiselect = _resolveComponent("VueMultiselect")!
  const _component_Field = _resolveComponent("Field")!
  const _component_Spinner = _resolveComponent("Spinner")!
  const _component_AnagraficaAzienda = _resolveComponent("AnagraficaAzienda")!
  const _component_AnagraficaDenominazione = _resolveComponent("AnagraficaDenominazione")!
  const _component_IbanForm = _resolveComponent("IbanForm")!
  const _component_MultiselectOption = _resolveComponent("MultiselectOption")!
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_FileUpload = _resolveComponent("FileUpload")!
  const _component_Modal = _resolveComponent("Modal")!
  const _component_NextEditor = _resolveComponent("NextEditor")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_openBlock(), _createBlock(_Teleport, { to: "#modal" }, [
      _createVNode(_component_Loading, { visible: _ctx.loading }, null, 8, ["visible"])
    ])),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        (_ctx.show_error_form)
          ? (_openBlock(), _createBlock(_component_Alert, {
              key: 0,
              dismissable: true,
              onClose: _cache[0] || (_cache[0] = ($event: any) => (_ctx.show_error_form = false)),
              class: "bg-next-orange drop-shadow-lg w-96 fixed top-5 right-5 z-50"
            }, {
              default: _withCtx(() => _cache[67] || (_cache[67] = [
                _createTextVNode(" Correggi gli errori di inserimento ")
              ])),
              _: 1
            }))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_3, [
          _createVNode(_component_Breadcrumbs, { paths: _ctx.getBreadcrumbsPath }, null, 8, ["paths"]),
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_NextButton, {
              variant: "outline-secondary",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.back())),
              class: "w-48 hidden text-sm sm:block py-2 px-4"
            }, {
              default: _withCtx(() => _cache[68] || (_cache[68] = [
                _createTextVNode(" < Indietro ")
              ])),
              _: 1
            }),
            _createVNode(_component_NextButton, {
              variant: "primary",
              onClick: _ctx.save,
              class: "w-48 text-sm sm:block py-2 px-4 ml-3"
            }, {
              default: _withCtx(() => _cache[69] || (_cache[69] = [
                _createTextVNode("Salva "),
                _createElementVNode("i", { class: "spinner" }, null, -1)
              ])),
              _: 1
            }, 8, ["onClick"])
          ])
        ]),
        _cache[112] || (_cache[112] = _createElementVNode("h3", { class: "text-3xl font-bold mb-6" }, "Nuovo fornitore", -1)),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_Field, {
            field_name: "Denominazione",
            required: !_ctx.anagraficheAutocomplete.selection,
            errors: _ctx.getErrors('anagrafica_denominazione_id')
          }, {
            default: _withCtx(() => [
              _createVNode(_component_VueMultiselect, {
                modelValue: _ctx.anagraficheAutocomplete.selection,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.anagraficheAutocomplete.selection) = $event)),
                options: _ctx.anagraficheAutocomplete.options,
                taggable: true,
                "clear-on-select": false,
                preserveSearch: true,
                onTag: _cache[3] || (_cache[3] = (value)=>_ctx.anagraficheAutocomplete.add({id:-1, denominazione:value})),
                placeholder: "Denominazione",
                tagPlaceholder: "Crea nuova denominazione",
                class: "next-vue-multiselect-single",
                "track-by": "id",
                label: "denominazione",
                selectLabel: "",
                deselectLabel: "",
                selectedLabel: "",
                "internal-search": false,
                onSearchChange: _ctx.anagraficheAutocompleteSarch
              }, {
                option: _withCtx(({option}) => [
                  _createElementVNode("div", {
                    class: _normalizeClass(["flex flex-col text-sm p-3", _ctx.getDenominazioneOptionColor(option)])
                  }, [
                    (option.isTag)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_6, [
                          _cache[70] || (_cache[70] = _createTextVNode("Aggiungi denominazione: ")),
                          _createElementVNode("span", _hoisted_7, _toDisplayString(option.label), 1)
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                          _createElementVNode("div", _hoisted_9, [
                            _createElementVNode("span", null, [
                              _cache[71] || (_cache[71] = _createTextVNode("Denominazione: ")),
                              _createElementVNode("span", _hoisted_10, _toDisplayString(option.denominazione), 1)
                            ]),
                            _createElementVNode("span", null, [
                              _cache[72] || (_cache[72] = _createTextVNode("Ragione sociale: ")),
                              _createElementVNode("span", _hoisted_11, _toDisplayString(option.ragione_sociale), 1)
                            ]),
                            _createElementVNode("span", null, [
                              _cache[73] || (_cache[73] = _createTextVNode("Partita IVA: ")),
                              _createElementVNode("span", _hoisted_12, _toDisplayString(option.partita_iva), 1)
                            ]),
                            _createElementVNode("span", null, [
                              _cache[74] || (_cache[74] = _createTextVNode("CF: ")),
                              _createElementVNode("span", _hoisted_13, _toDisplayString(option.codice_fiscale), 1)
                            ])
                          ])
                        ]))
                  ], 2)
                ]),
                _: 1
              }, 8, ["modelValue", "options", "onSearchChange"])
            ]),
            _: 1
          }, 8, ["required", "errors"])
        ]),
        _createElementVNode("div", _hoisted_14, [
          _cache[76] || (_cache[76] = _createElementVNode("h6", { class: "px-3 -translate-y-1/2 translate-x-3 top-0 absolute bg-next-light-gray" }, "Anagrafica gamma", -1)),
          (_ctx.hasPermission('set id_gamma'))
            ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                _createVNode(_component_Field, {
                  field_name: "ID gamma",
                  type: "number",
                  errors: _ctx.getErrors('id_gamma')
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_16, [
                      _withDirectives(_createElementVNode("input", {
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.fornitore_model.id_gamma) = $event)),
                        type: "number",
                        class: "p-2 bg-next-gray-md-dark hover:bg-white w-full pr-7"
                      }, null, 512), [
                        [_vModelText, _ctx.fornitore_model.id_gamma]
                      ]),
                      _withDirectives(_createVNode(_component_Spinner, { class: "w-5 absolute right-1" }, null, 512), [
                        [_vShow, _ctx.anagrafica_gamma_loading]
                      ])
                    ])
                  ]),
                  _: 1
                }, 8, ["errors"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.anagrafica_gamma?.CG16_CODICE)
            ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                _createElementVNode("span", null, "Ragione sociale: " + _toDisplayString(_ctx.anagrafica_gamma.CG16_RAGSOANAG), 1),
                _createElementVNode("span", null, "Partita IVA: " + _toDisplayString(_ctx.anagrafica_gamma.CG16_PARTIVA), 1),
                _createElementVNode("span", null, "Codice fiscale: " + _toDisplayString(_ctx.anagrafica_gamma.CG16_CODFISCALE), 1)
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_18, _cache[75] || (_cache[75] = [
                _createElementVNode("span", null, "Azienda gamma non associata", -1)
              ])))
        ]),
        _createVNode(_component_AnagraficaAzienda, {
          errors: _ctx.errors,
          "onUpdate:azienda_id": [
            _ctx.onUpdateAziendaId,
            _cache[5] || (_cache[5] = ($event: any) => ((_ctx.fornitore_model.azienda_id) = $event))
          ],
          disable_dati_azienda: _ctx.disable_dati_azienda,
          disable_autocomplete_azienda: _ctx.disable_autocomplete_azienda,
          azienda_id: _ctx.fornitore_model.azienda_id,
          place_id: _ctx.fornitore_model.a_place_id,
          "onUpdate:place_id": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.fornitore_model.a_place_id) = $event)),
          lat: _ctx.fornitore_model.a_lat,
          "onUpdate:lat": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.fornitore_model.a_lat) = $event)),
          lng: _ctx.fornitore_model.a_lng,
          "onUpdate:lng": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.fornitore_model.a_lng) = $event)),
          estera: _ctx.fornitore_model.estera,
          "onUpdate:estera": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.fornitore_model.estera) = $event)),
          tipo: _ctx.fornitore_model.tipo,
          "onUpdate:tipo": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.fornitore_model.tipo) = $event)),
          partita_iva: _ctx.fornitore_model.partita_iva,
          "onUpdate:partita_iva": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.fornitore_model.partita_iva) = $event)),
          codice_fiscale: _ctx.fornitore_model.codice_fiscale,
          "onUpdate:codice_fiscale": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.fornitore_model.codice_fiscale) = $event)),
          ragione_sociale: _ctx.fornitore_model.ragione_sociale,
          "onUpdate:ragione_sociale": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.fornitore_model.ragione_sociale) = $event)),
          sede_legale_nazione_id: _ctx.fornitore_model.sede_legale_nazione_id,
          "onUpdate:sede_legale_nazione_id": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.fornitore_model.sede_legale_nazione_id) = $event)),
          sede_legale_provincia_id: _ctx.fornitore_model.sede_legale_provincia_id,
          "onUpdate:sede_legale_provincia_id": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.fornitore_model.sede_legale_provincia_id) = $event)),
          sede_legale_comune_id: _ctx.fornitore_model.sede_legale_comune_id,
          "onUpdate:sede_legale_comune_id": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.fornitore_model.sede_legale_comune_id) = $event)),
          sede_legale_regione_estero: _ctx.fornitore_model.sede_legale_regione_estero,
          "onUpdate:sede_legale_regione_estero": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.fornitore_model.sede_legale_regione_estero) = $event)),
          sede_legale_citta_estero: _ctx.fornitore_model.sede_legale_citta_estero,
          "onUpdate:sede_legale_citta_estero": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.fornitore_model.sede_legale_citta_estero) = $event)),
          sede_legale_via: _ctx.fornitore_model.sede_legale_via,
          "onUpdate:sede_legale_via": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.fornitore_model.sede_legale_via) = $event)),
          sede_legale_cap: _ctx.fornitore_model.sede_legale_cap,
          "onUpdate:sede_legale_cap": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.fornitore_model.sede_legale_cap) = $event)),
          sede_legale_numero: _ctx.fornitore_model.sede_legale_numero,
          "onUpdate:sede_legale_numero": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.fornitore_model.sede_legale_numero) = $event))
        }, null, 8, ["errors", "onUpdate:azienda_id", "disable_dati_azienda", "disable_autocomplete_azienda", "azienda_id", "place_id", "lat", "lng", "estera", "tipo", "partita_iva", "codice_fiscale", "ragione_sociale", "sede_legale_nazione_id", "sede_legale_provincia_id", "sede_legale_comune_id", "sede_legale_regione_estero", "sede_legale_citta_estero", "sede_legale_via", "sede_legale_cap", "sede_legale_numero"]),
        _createVNode(_component_AnagraficaDenominazione, {
          errors: _ctx.errors,
          disabled: _ctx.disable_dati_denominazione,
          anagrafica_denominazione_id: _ctx.fornitore_model.anagrafica_denominazione_id,
          "onUpdate:anagrafica_denominazione_id": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.fornitore_model.anagrafica_denominazione_id) = $event)),
          denominazione: _ctx.fornitore_model.denominazione,
          "onUpdate:denominazione": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.fornitore_model.denominazione) = $event)),
          sito: _ctx.fornitore_model.sito,
          "onUpdate:sito": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.fornitore_model.sito) = $event)),
          gruppo_di_appartenenza: _ctx.fornitore_model.gruppo_di_appartenenza,
          "onUpdate:gruppo_di_appartenenza": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.fornitore_model.gruppo_di_appartenenza) = $event)),
          place_id: _ctx.fornitore_model.place_id,
          "onUpdate:place_id": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.fornitore_model.place_id) = $event)),
          lat: _ctx.fornitore_model.lat,
          "onUpdate:lat": _cache[27] || (_cache[27] = ($event: any) => ((_ctx.fornitore_model.lat) = $event)),
          lng: _ctx.fornitore_model.lng,
          "onUpdate:lng": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.fornitore_model.lng) = $event)),
          sede_operativa_via: _ctx.fornitore_model.sede_operativa_via,
          "onUpdate:sede_operativa_via": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.fornitore_model.sede_operativa_via) = $event)),
          sede_operativa_numero: _ctx.fornitore_model.sede_operativa_numero,
          "onUpdate:sede_operativa_numero": _cache[30] || (_cache[30] = ($event: any) => ((_ctx.fornitore_model.sede_operativa_numero) = $event)),
          sede_operativa_nazione_id: _ctx.fornitore_model.sede_operativa_nazione_id,
          "onUpdate:sede_operativa_nazione_id": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.fornitore_model.sede_operativa_nazione_id) = $event)),
          sede_operativa_cap: _ctx.fornitore_model.sede_operativa_cap,
          "onUpdate:sede_operativa_cap": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.fornitore_model.sede_operativa_cap) = $event)),
          sede_operativa_regione_estero: _ctx.fornitore_model.sede_operativa_regione_estero,
          "onUpdate:sede_operativa_regione_estero": _cache[33] || (_cache[33] = ($event: any) => ((_ctx.fornitore_model.sede_operativa_regione_estero) = $event)),
          sede_operativa_citta_estero: _ctx.fornitore_model.sede_operativa_citta_estero,
          "onUpdate:sede_operativa_citta_estero": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.fornitore_model.sede_operativa_citta_estero) = $event)),
          sede_operativa_provincia_id: _ctx.fornitore_model.sede_operativa_provincia_id,
          "onUpdate:sede_operativa_provincia_id": _cache[35] || (_cache[35] = ($event: any) => ((_ctx.fornitore_model.sede_operativa_provincia_id) = $event)),
          sede_operativa_comune_id: _ctx.fornitore_model.sede_operativa_comune_id,
          "onUpdate:sede_operativa_comune_id": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.fornitore_model.sede_operativa_comune_id) = $event)),
          email: _ctx.fornitore_model.email,
          "onUpdate:email": _cache[37] || (_cache[37] = ($event: any) => ((_ctx.fornitore_model.email) = $event)),
          pec: _ctx.fornitore_model.pec,
          "onUpdate:pec": _cache[38] || (_cache[38] = ($event: any) => ((_ctx.fornitore_model.pec) = $event)),
          telefono_1: _ctx.fornitore_model.telefono_1,
          "onUpdate:telefono_1": _cache[39] || (_cache[39] = ($event: any) => ((_ctx.fornitore_model.telefono_1) = $event)),
          telefono_2: _ctx.fornitore_model.telefono_2,
          "onUpdate:telefono_2": _cache[40] || (_cache[40] = ($event: any) => ((_ctx.fornitore_model.telefono_2) = $event)),
          fax: _ctx.fornitore_model.fax,
          "onUpdate:fax": _cache[41] || (_cache[41] = ($event: any) => ((_ctx.fornitore_model.fax) = $event))
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_19, [
              _createVNode(_component_NextButton, {
                onClick: _ctx.copiaDaSedeLegale,
                class: "w-50 p-3"
              }, {
                default: _withCtx(() => _cache[77] || (_cache[77] = [
                  _createTextVNode("Copia dati dalla sede legale")
                ])),
                _: 1
              }, 8, ["onClick"])
            ])
          ]),
          _: 1
        }, 8, ["errors", "disabled", "anagrafica_denominazione_id", "denominazione", "sito", "gruppo_di_appartenenza", "place_id", "lat", "lng", "sede_operativa_via", "sede_operativa_numero", "sede_operativa_nazione_id", "sede_operativa_cap", "sede_operativa_regione_estero", "sede_operativa_citta_estero", "sede_operativa_provincia_id", "sede_operativa_comune_id", "email", "pec", "telefono_1", "telefono_2", "fax"]),
        _createElementVNode("div", _hoisted_20, [
          _cache[78] || (_cache[78] = _createElementVNode("h6", { class: "px-3 -translate-y-1/2 translate-x-3 top-0 absolute bg-next-light-gray" }, "IBAN", -1)),
          _createVNode(_component_IbanForm, {
            ibans: _ctx.fornitore_model.ibans,
            "onUpdate:ibans": _cache[42] || (_cache[42] = ($event: any) => ((_ctx.fornitore_model.ibans) = $event)),
            errors: _ctx.errors
          }, null, 8, ["ibans", "errors"])
        ]),
        _createElementVNode("div", _hoisted_21, [
          _cache[82] || (_cache[82] = _createElementVNode("h6", { class: "px-3 -translate-y-1/2 translate-x-3 top-0 absolute bg-next-light-gray" }, "Assegnazioni fornitore", -1)),
          _createElementVNode("div", _hoisted_22, [
            _createVNode(_component_Field, {
              field_name: "Settore merceologico",
              required: true,
              modelValue: _ctx.settoriSelections,
              "onUpdate:modelValue": _cache[44] || (_cache[44] = ($event: any) => ((_ctx.settoriSelections) = $event)),
              errors: _ctx.getErrors('settori_merceologici')
            }, {
              default: _withCtx(() => [
                _createVNode(_component_VueMultiselect, {
                  searchable: true,
                  "internal-search": false,
                  multiple: true,
                  trackBy: "id",
                  label: "descrizione",
                  onSearchChange: _ctx.settore_merceologico_autocomplete.search,
                  modelValue: _ctx.settore_merceologico_autocomplete.selection,
                  "onUpdate:modelValue": _cache[43] || (_cache[43] = ($event: any) => ((_ctx.settore_merceologico_autocomplete.selection) = $event)),
                  options: _ctx.settore_merceologico_autocomplete.options,
                  "close-on-select": false,
                  "clear-on-select": false,
                  placeholder: "Settore",
                  deselectLabel: "Deseleziona",
                  selectedLabel: "Selezionato",
                  selectLabel: "Seleziona",
                  class: "next-vue-multiselect"
                }, {
                  tag: _withCtx(({option, remove}) => [
                    _createVNode(_component_MultiselectOption, {
                      onRemove: ($event: any) => (remove(option))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(option.descrizione), 1)
                      ]),
                      _: 2
                    }, 1032, ["onRemove"])
                  ]),
                  _: 1
                }, 8, ["onSearchChange", "modelValue", "options"])
              ]),
              _: 1
            }, 8, ["modelValue", "errors"])
          ]),
          (_ctx.hasPermission('approve fornitori'))
            ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                _createVNode(_component_Field, {
                  field_name: "Qualifica",
                  required: true,
                  modelValue: _ctx.fornitore_model.qualifica,
                  "onUpdate:modelValue": _cache[46] || (_cache[46] = ($event: any) => ((_ctx.fornitore_model.qualifica) = $event)),
                  errors: _ctx.getErrors('qualifica')
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_VueMultiselect, {
                      searchable: true,
                      "internal-search": false,
                      multiple: false,
                      trackBy: "id",
                      label: "text",
                      onSearchChange: _ctx.qualifica_autocomplete.search,
                      modelValue: _ctx.qualifica_autocomplete.selection,
                      "onUpdate:modelValue": _cache[45] || (_cache[45] = ($event: any) => ((_ctx.qualifica_autocomplete.selection) = $event)),
                      options: _ctx.qualifica_autocomplete.options,
                      "close-on-select": true,
                      "clear-on-select": true,
                      placeholder: "Qualifica",
                      deselectLabel: "Deseleziona",
                      selectedLabel: "Selezionato",
                      selectLabel: "Seleziona",
                      class: "next-vue-multiselect-single"
                    }, null, 8, ["onSearchChange", "modelValue", "options"])
                  ]),
                  _: 1
                }, 8, ["modelValue", "errors"])
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_24, [
            _createVNode(_component_Field, {
              field_name: "Accordo quadro",
              errors: _ctx.getErrors('quadro_file_id')
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_25, [
                  _createVNode(_component_Checkbox, {
                    class: "pt-3",
                    checkClass: "h-4 w-4",
                    checked: _ctx.fornitore_model.accordo_quadro,
                    onChange: _cache[47] || (_cache[47] = ($event: any) => (_ctx.fornitore_model.accordo_quadro = !_ctx.fornitore_model.accordo_quadro)),
                    for_id: "quadro"
                  }, null, 8, ["checked"]),
                  _createVNode(_component_FileUpload, {
                    uploaded_files: _ctx.uploaded_quadro,
                    "onUpdate:uploaded_files": _cache[48] || (_cache[48] = ($event: any) => ((_ctx.uploaded_quadro) = $event)),
                    model_files: _ctx.allegati_quadro,
                    "onUpdate:model_files": _cache[49] || (_cache[49] = ($event: any) => ((_ctx.allegati_quadro) = $event)),
                    to_delete: _ctx.to_delete_quadro,
                    "onUpdate:to_delete": _cache[50] || (_cache[50] = ($event: any) => ((_ctx.to_delete_quadro) = $event)),
                    accept: ".pdf,.doc,.docx,.eml,.jpg,.jpeg,.png,.csv,.txt,.xlx,.xls,.xlsx"
                  }, {
                    default: _withCtx(({props, methods}) => [
                      _createElementVNode("div", {
                        class: _normalizeClass([{'invisible': !_ctx.fornitore_model.accordo_quadro}, "flex flex-col grow"])
                      }, [
                        _createVNode(_component_NextButton, {
                          variant: "outline-secondary",
                          onClick: methods.open,
                          class: "w-full h-10 px-4 grow mb-2"
                        }, {
                          default: _withCtx(() => _cache[79] || (_cache[79] = [
                            _createElementVNode("i", { class: "icon icon-graffetta" }, null, -1),
                            _createTextVNode(" Allega ")
                          ])),
                          _: 2
                        }, 1032, ["onClick"]),
                        _createElementVNode("div", _hoisted_26, [
                          _withDirectives(_createElementVNode("div", null, [
                            _cache[80] || (_cache[80] = _createElementVNode("span", null, "Nuovo: ", -1)),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.uploaded_quadro, (f, idx) => {
                              return (_openBlock(), _createElementBlock("a", _hoisted_27, [
                                _createElementVNode("span", null, _toDisplayString(f.name), 1)
                              ]))
                            }), 256))
                          ], 512), [
                            [_vShow, _ctx.uploaded_quadro.length]
                          ]),
                          _createElementVNode("div", null, [
                            _cache[81] || (_cache[81] = _createElementVNode("span", null, "Attualmente presente: ", -1)),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allegati_quadro, (f, idx) => {
                              return (_openBlock(), _createElementBlock("a", _hoisted_28, [
                                _createElementVNode("span", null, _toDisplayString(f.name), 1)
                              ]))
                            }), 256))
                          ])
                        ]),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.errors, (e, i) => {
                          return (_openBlock(), _createElementBlock("small", {
                            key: i,
                            class: "text-next-orange"
                          }, _toDisplayString(e.join(', ')), 1))
                        }), 128))
                      ], 2)
                    ]),
                    _: 1
                  }, 8, ["uploaded_files", "model_files", "to_delete"])
                ])
              ]),
              _: 1
            }, 8, ["errors"])
          ])
        ]),
        _createElementVNode("div", _hoisted_29, [
          _withDirectives(_createElementVNode("div", _hoisted_30, [
            _createVNode(_component_FileUpload, {
              uploaded_files: _ctx.uploaded_polizze,
              "onUpdate:uploaded_files": _cache[53] || (_cache[53] = ($event: any) => ((_ctx.uploaded_polizze) = $event)),
              model_files: _ctx.allegati_polizze,
              "onUpdate:model_files": _cache[54] || (_cache[54] = ($event: any) => ((_ctx.allegati_polizze) = $event)),
              to_delete: _ctx.to_delete_polizze,
              "onUpdate:to_delete": _cache[55] || (_cache[55] = ($event: any) => ((_ctx.to_delete_polizze) = $event)),
              multiple: "",
              accept: ".pdf,.doc,.docx,.eml,.jpg,.jpeg,.png,.csv,.txt,.xlx,.xls,.xlsx"
            }, {
              default: _withCtx(({props, methods}) => [
                _createElementVNode("div", _hoisted_31, [
                  _cache[88] || (_cache[88] = _createElementVNode("h3", { class: "font-bold justify-self-start" }, "Polizza RCT/O", -1)),
                  _createElementVNode("div", _hoisted_32, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allegati_polizze, (f, idx) => {
                      return (_openBlock(), _createElementBlock("a", {
                        class: "underline text-sm text-next-atp pt-3 break-words bg-next-gray-md-dark p-3 cursor-pointer",
                        onClick: ($event: any) => (_ctx.downloadFile(f?.id)),
                        key: `a_${idx}`
                      }, [
                        _cache[83] || (_cache[83] = _createElementVNode("i", { class: "icon icon-graffetta" }, null, -1)),
                        _cache[84] || (_cache[84] = _createTextVNode()),
                        _createElementVNode("span", null, _toDisplayString(f.name), 1)
                      ], 8, _hoisted_33))
                    }), 128)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.uploaded_polizze_to_save, (f, idx) => {
                      return (_openBlock(), _createElementBlock("a", {
                        class: "underline text-sm text-next-atp pt-3 break-words bg-next-gray-md-dark p-3 cursor-pointer",
                        onClick: ($event: any) => (_ctx.downloadFile(f?.id)),
                        key: `u_${idx}`
                      }, [
                        _cache[85] || (_cache[85] = _createElementVNode("i", { class: "icon icon-graffetta" }, null, -1)),
                        _cache[86] || (_cache[86] = _createTextVNode()),
                        _createElementVNode("span", null, _toDisplayString(f.name), 1)
                      ], 8, _hoisted_34))
                    }), 128)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.links_polizze, (f, idx) => {
                      return (_openBlock(), _createElementBlock("a", {
                        class: "underline text-sm text-next-atp pt-3 break-words bg-next-gray-md-dark p-3",
                        href: f.url,
                        key: `la_${idx}`
                      }, [
                        _createElementVNode("span", null, _toDisplayString(f.url), 1)
                      ], 8, _hoisted_35))
                    }), 128)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.links_polizze_to_save, (f, idx) => {
                      return (_openBlock(), _createElementBlock("a", {
                        class: "underline text-sm text-next-atp pt-3 break-words bg-next-gray-md-dark p-3",
                        href: f.url,
                        key: `las_${idx}`
                      }, [
                        _createElementVNode("span", null, _toDisplayString(f.url), 1)
                      ], 8, _hoisted_36))
                    }), 128))
                  ]),
                  _createVNode(_component_NextButton, {
                    variant: "outline-secondary",
                    onClick: _cache[51] || (_cache[51] = ($event: any) => (_ctx.polizze_visible=true)),
                    class: "w-full h-10 px-4"
                  }, {
                    default: _withCtx(() => _cache[87] || (_cache[87] = [
                      _createElementVNode("i", { class: "icon icon-graffetta" }, null, -1),
                      _createTextVNode(" Allega ")
                    ])),
                    _: 1
                  })
                ]),
                _createVNode(_component_Modal, {
                  visible: _ctx.polizze_visible,
                  backdrop: true
                }, {
                  main: _withCtx(() => [
                    _withDirectives(_createElementVNode("div", _hoisted_37, [
                      _createVNode(_component_Field, {
                        field_name: "Link",
                        modelValue: _ctx.polizze_link,
                        "onUpdate:modelValue": _cache[52] || (_cache[52] = ($event: any) => ((_ctx.polizze_link) = $event))
                      }, null, 8, ["modelValue"]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.errors, (e, i) => {
                        return (_openBlock(), _createElementBlock("small", {
                          key: i,
                          class: "text-next-orange"
                        }, _toDisplayString(e.join(', ')), 1))
                      }), 128)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.polizze_errors, (e, i) => {
                        return (_openBlock(), _createElementBlock("small", {
                          key: i,
                          class: "text-next-orange"
                        }, _toDisplayString(e), 1))
                      }), 128))
                    ], 512), [
                      [_vShow, !_ctx.uploaded_polizze.length]
                    ]),
                    _withDirectives(_createElementVNode("div", _hoisted_38, [
                      (!_ctx.uploaded_polizze.length)
                        ? (_openBlock(), _createBlock(_component_NextButton, {
                            key: 0,
                            variant: "outline-secondary",
                            onClick: methods.open,
                            class: "w-full h-10 px-4"
                          }, {
                            default: _withCtx(() => _cache[89] || (_cache[89] = [
                              _createElementVNode("i", { class: "icon icon-graffetta" }, null, -1),
                              _createTextVNode(" Allega ")
                            ])),
                            _: 2
                          }, 1032, ["onClick"]))
                        : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.uploaded_polizze, (f, idx) => {
                            return (_openBlock(), _createBlock(_component_Field, {
                              key: `u_${idx}`,
                              field_name: "Allegato",
                              modelValue: f.name,
                              "onUpdate:modelValue": ($event: any) => ((f.name) = $event),
                              "input-attrs": {disabled:true}
                            }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                          }), 128))
                    ], 512), [
                      [_vShow, !_ctx.polizze_link.length]
                    ])
                  ]),
                  footer: _withCtx(() => [
                    _createElementVNode("div", _hoisted_39, [
                      _createVNode(_component_NextButton, {
                        variant: "primary",
                        onClick: _ctx.salvaPolizze,
                        class: "w-full h-10 px-4"
                      }, {
                        default: _withCtx(() => _cache[90] || (_cache[90] = [
                          _createTextVNode("Salva ")
                        ])),
                        _: 1
                      }, 8, ["onClick"]),
                      _createVNode(_component_NextButton, {
                        variant: "outline-primary",
                        onClick: ($event: any) => {methods.reset();_ctx.chiudiPolizze()},
                        class: "w-full h-10 px-4"
                      }, {
                        default: _withCtx(() => _cache[91] || (_cache[91] = [
                          _createTextVNode("Chiudi ")
                        ])),
                        _: 2
                      }, 1032, ["onClick"])
                    ])
                  ]),
                  _: 2
                }, 1032, ["visible"])
              ]),
              _: 1
            }, 8, ["uploaded_files", "model_files", "to_delete"])
          ], 512), [
            [_vShow, _ctx.requiredPolizze]
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_40, [
            _createVNode(_component_FileUpload, {
              uploaded_files: _ctx.uploaded_visure,
              "onUpdate:uploaded_files": _cache[58] || (_cache[58] = ($event: any) => ((_ctx.uploaded_visure) = $event)),
              model_files: _ctx.allegati_visure,
              "onUpdate:model_files": _cache[59] || (_cache[59] = ($event: any) => ((_ctx.allegati_visure) = $event)),
              to_delete: _ctx.to_delete_visure,
              "onUpdate:to_delete": _cache[60] || (_cache[60] = ($event: any) => ((_ctx.to_delete_visure) = $event)),
              multiple: "",
              accept: ".pdf,.doc,.docx,.eml,.jpg,.jpeg,.png,.csv,.txt,.xlx,.xls,.xlsx"
            }, {
              default: _withCtx(({props, methods}) => [
                _createElementVNode("div", _hoisted_41, [
                  _cache[97] || (_cache[97] = _createElementVNode("h3", { class: "font-bold justify-self-start" }, "Visura", -1)),
                  _createElementVNode("div", _hoisted_42, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allegati_visure, (f, idx) => {
                      return (_openBlock(), _createElementBlock("a", {
                        class: "underline text-sm text-next-atp pt-3 break-words bg-next-gray-md-dark p-3 cursor-pointer",
                        onClick: ($event: any) => (_ctx.downloadFile(f?.id)),
                        key: `a_${idx}`
                      }, [
                        _cache[92] || (_cache[92] = _createElementVNode("i", { class: "icon icon-graffetta" }, null, -1)),
                        _cache[93] || (_cache[93] = _createTextVNode()),
                        _createElementVNode("span", null, _toDisplayString(f.name), 1)
                      ], 8, _hoisted_43))
                    }), 128)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.uploaded_visure_to_save, (f, idx) => {
                      return (_openBlock(), _createElementBlock("a", {
                        class: "underline text-sm text-next-atp pt-3 break-words bg-next-gray-md-dark p-3 cursor-pointer",
                        onClick: ($event: any) => (_ctx.downloadFile(f?.id)),
                        key: `u_${idx}`
                      }, [
                        _cache[94] || (_cache[94] = _createElementVNode("i", { class: "icon icon-graffetta" }, null, -1)),
                        _cache[95] || (_cache[95] = _createTextVNode()),
                        _createElementVNode("span", null, _toDisplayString(f.name), 1)
                      ], 8, _hoisted_44))
                    }), 128)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.links_visure, (f, idx) => {
                      return (_openBlock(), _createElementBlock("a", {
                        class: "underline text-sm text-next-atp pt-3 break-words bg-next-gray-md-dark p-3",
                        href: f.url,
                        key: `la_${idx}`
                      }, [
                        _createElementVNode("span", null, _toDisplayString(f.url), 1)
                      ], 8, _hoisted_45))
                    }), 128)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.links_visure_to_save, (f, idx) => {
                      return (_openBlock(), _createElementBlock("a", {
                        class: "underline text-sm text-next-atp pt-3 break-words bg-next-gray-md-dark p-3",
                        href: f.url,
                        key: `las_${idx}`
                      }, [
                        _createElementVNode("span", null, _toDisplayString(f.url), 1)
                      ], 8, _hoisted_46))
                    }), 128))
                  ]),
                  _createVNode(_component_NextButton, {
                    variant: "outline-secondary",
                    onClick: _cache[56] || (_cache[56] = ($event: any) => (_ctx.visure_visible=true)),
                    class: "w-full h-10 px-4"
                  }, {
                    default: _withCtx(() => _cache[96] || (_cache[96] = [
                      _createElementVNode("i", { class: "icon icon-graffetta" }, null, -1),
                      _createTextVNode(" Allega ")
                    ])),
                    _: 1
                  })
                ]),
                _createVNode(_component_Modal, {
                  visible: _ctx.visure_visible,
                  backdrop: true
                }, {
                  main: _withCtx(() => [
                    _withDirectives(_createElementVNode("div", _hoisted_47, [
                      _createVNode(_component_Field, {
                        field_name: "Link",
                        modelValue: _ctx.visure_link,
                        "onUpdate:modelValue": _cache[57] || (_cache[57] = ($event: any) => ((_ctx.visure_link) = $event))
                      }, null, 8, ["modelValue"]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.errors, (e, i) => {
                        return (_openBlock(), _createElementBlock("small", {
                          key: i,
                          class: "text-next-orange"
                        }, _toDisplayString(e.join(', ')), 1))
                      }), 128)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.visure_errors, (e, i) => {
                        return (_openBlock(), _createElementBlock("small", {
                          key: i,
                          class: "text-next-orange"
                        }, _toDisplayString(e), 1))
                      }), 128))
                    ], 512), [
                      [_vShow, !_ctx.uploaded_visure.length]
                    ]),
                    _withDirectives(_createElementVNode("div", _hoisted_48, [
                      (!_ctx.uploaded_visure.length)
                        ? (_openBlock(), _createBlock(_component_NextButton, {
                            key: 0,
                            variant: "outline-secondary",
                            onClick: methods.open,
                            class: "w-full h-10 px-4"
                          }, {
                            default: _withCtx(() => _cache[98] || (_cache[98] = [
                              _createElementVNode("i", { class: "icon icon-graffetta" }, null, -1),
                              _createTextVNode(" Allega ")
                            ])),
                            _: 2
                          }, 1032, ["onClick"]))
                        : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.uploaded_visure, (f, idx) => {
                            return (_openBlock(), _createBlock(_component_Field, {
                              key: `u_${idx}`,
                              field_name: "Allegato",
                              modelValue: f.name,
                              "onUpdate:modelValue": ($event: any) => ((f.name) = $event),
                              "input-attrs": {disabled:true}
                            }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                          }), 128))
                    ], 512), [
                      [_vShow, !_ctx.visure_link.length]
                    ])
                  ]),
                  footer: _withCtx(() => [
                    _createElementVNode("div", _hoisted_49, [
                      _createVNode(_component_NextButton, {
                        variant: "primary",
                        onClick: _ctx.salvaVisure,
                        class: "w-full h-10 px-4"
                      }, {
                        default: _withCtx(() => _cache[99] || (_cache[99] = [
                          _createTextVNode("Salva ")
                        ])),
                        _: 1
                      }, 8, ["onClick"]),
                      _createVNode(_component_NextButton, {
                        variant: "outline-primary",
                        onClick: ($event: any) => {methods.reset();_ctx.chiudiVisure()},
                        class: "w-full h-10 px-4"
                      }, {
                        default: _withCtx(() => _cache[100] || (_cache[100] = [
                          _createTextVNode("Chiudi ")
                        ])),
                        _: 2
                      }, 1032, ["onClick"])
                    ])
                  ]),
                  _: 2
                }, 1032, ["visible"])
              ]),
              _: 1
            }, 8, ["uploaded_files", "model_files", "to_delete"])
          ], 512), [
            [_vShow, _ctx.requiredVisure]
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_50, [
            _createVNode(_component_FileUpload, {
              uploaded_files: _ctx.uploaded_albo,
              "onUpdate:uploaded_files": _cache[63] || (_cache[63] = ($event: any) => ((_ctx.uploaded_albo) = $event)),
              model_files: _ctx.allegati_albo,
              "onUpdate:model_files": _cache[64] || (_cache[64] = ($event: any) => ((_ctx.allegati_albo) = $event)),
              to_delete: _ctx.to_delete_albo,
              "onUpdate:to_delete": _cache[65] || (_cache[65] = ($event: any) => ((_ctx.to_delete_albo) = $event)),
              multiple: "",
              accept: ".pdf,.doc,.docx,.eml,.jpg,.jpeg,.png,.csv,.txt,.xlx,.xls,.xlsx"
            }, {
              default: _withCtx(({props, methods}) => [
                _createElementVNode("div", _hoisted_51, [
                  _cache[106] || (_cache[106] = _createElementVNode("h3", { class: "font-bold justify-self-start" }, "Iscrizione albo gestori", -1)),
                  _createElementVNode("div", _hoisted_52, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allegati_albo, (f, idx) => {
                      return (_openBlock(), _createElementBlock("a", {
                        class: "underline text-sm text-next-atp pt-3 break-words bg-next-gray-md-dark p-3 cursor-pointer",
                        onClick: ($event: any) => (_ctx.downloadFile(f?.id)),
                        key: `a_${idx}`
                      }, [
                        _cache[101] || (_cache[101] = _createElementVNode("i", { class: "icon icon-graffetta" }, null, -1)),
                        _cache[102] || (_cache[102] = _createTextVNode()),
                        _createElementVNode("span", null, _toDisplayString(f.name), 1)
                      ], 8, _hoisted_53))
                    }), 128)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.uploaded_albo_to_save, (f, idx) => {
                      return (_openBlock(), _createElementBlock("a", {
                        class: "underline text-sm text-next-atp pt-3 break-words bg-next-gray-md-dark p-3 cursor-pointer",
                        onClick: ($event: any) => (_ctx.downloadFile(f?.id)),
                        key: `u_${idx}`
                      }, [
                        _cache[103] || (_cache[103] = _createElementVNode("i", { class: "icon icon-graffetta" }, null, -1)),
                        _cache[104] || (_cache[104] = _createTextVNode()),
                        _createElementVNode("span", null, _toDisplayString(f.name), 1)
                      ], 8, _hoisted_54))
                    }), 128)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.links_albo, (f, idx) => {
                      return (_openBlock(), _createElementBlock("a", {
                        class: "underline text-sm text-next-atp pt-3 break-words bg-next-gray-md-dark p-3",
                        href: f.url,
                        key: `la_${idx}`
                      }, [
                        _createElementVNode("span", null, _toDisplayString(f.url), 1)
                      ], 8, _hoisted_55))
                    }), 128)),
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.links_albo_to_save, (f, idx) => {
                      return (_openBlock(), _createElementBlock("a", {
                        class: "underline text-sm text-next-atp pt-3 break-words bg-next-gray-md-dark p-3",
                        href: f.url,
                        key: `las_${idx}`
                      }, [
                        _createElementVNode("span", null, _toDisplayString(f.url), 1)
                      ], 8, _hoisted_56))
                    }), 128))
                  ]),
                  _createVNode(_component_NextButton, {
                    variant: "outline-secondary",
                    onClick: _cache[61] || (_cache[61] = ($event: any) => (_ctx.albo_visible=true)),
                    class: "w-full h-10 px-4"
                  }, {
                    default: _withCtx(() => _cache[105] || (_cache[105] = [
                      _createElementVNode("i", { class: "icon icon-graffetta" }, null, -1),
                      _createTextVNode(" Allega ")
                    ])),
                    _: 1
                  })
                ]),
                _createVNode(_component_Modal, {
                  visible: _ctx.albo_visible,
                  backdrop: true
                }, {
                  main: _withCtx(() => [
                    _withDirectives(_createElementVNode("div", _hoisted_57, [
                      _createVNode(_component_Field, {
                        field_name: "Link",
                        modelValue: _ctx.albo_link,
                        "onUpdate:modelValue": _cache[62] || (_cache[62] = ($event: any) => ((_ctx.albo_link) = $event))
                      }, null, 8, ["modelValue"]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(props.errors, (e, i) => {
                        return (_openBlock(), _createElementBlock("small", {
                          key: i,
                          class: "text-next-orange"
                        }, _toDisplayString(e.join(', ')), 1))
                      }), 128)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.albi_errors, (e, i) => {
                        return (_openBlock(), _createElementBlock("small", {
                          key: i,
                          class: "text-next-orange"
                        }, _toDisplayString(e), 1))
                      }), 128))
                    ], 512), [
                      [_vShow, !_ctx.uploaded_albo.length]
                    ]),
                    _withDirectives(_createElementVNode("div", _hoisted_58, [
                      (!_ctx.uploaded_albo.length)
                        ? (_openBlock(), _createBlock(_component_NextButton, {
                            key: 0,
                            variant: "outline-secondary",
                            onClick: methods.open,
                            class: "w-full h-10 px-4"
                          }, {
                            default: _withCtx(() => _cache[107] || (_cache[107] = [
                              _createElementVNode("i", { class: "icon icon-graffetta" }, null, -1),
                              _createTextVNode(" Allega ")
                            ])),
                            _: 2
                          }, 1032, ["onClick"]))
                        : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.uploaded_albo, (f, idx) => {
                            return (_openBlock(), _createBlock(_component_Field, {
                              key: `u_${idx}`,
                              field_name: "Allegato",
                              modelValue: f.name,
                              "onUpdate:modelValue": ($event: any) => ((f.name) = $event),
                              "input-attrs": {disabled:true}
                            }, null, 8, ["modelValue", "onUpdate:modelValue"]))
                          }), 128)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.albi_errors, (e, i) => {
                        return (_openBlock(), _createElementBlock("small", {
                          key: i,
                          class: "text-next-orange"
                        }, _toDisplayString(e), 1))
                      }), 128))
                    ], 512), [
                      [_vShow, !_ctx.albo_link.length]
                    ])
                  ]),
                  footer: _withCtx(() => [
                    _createElementVNode("div", _hoisted_59, [
                      _createVNode(_component_NextButton, {
                        variant: "primary",
                        onClick: _ctx.salvaAlbo,
                        class: "w-full h-10 px-4"
                      }, {
                        default: _withCtx(() => _cache[108] || (_cache[108] = [
                          _createTextVNode("Salva ")
                        ])),
                        _: 1
                      }, 8, ["onClick"]),
                      _createVNode(_component_NextButton, {
                        variant: "outline-primary",
                        onClick: ($event: any) => {methods.reset();_ctx.chiudiAlbo()},
                        class: "w-full h-10 px-4"
                      }, {
                        default: _withCtx(() => _cache[109] || (_cache[109] = [
                          _createTextVNode("Chiudi ")
                        ])),
                        _: 2
                      }, 1032, ["onClick"])
                    ])
                  ]),
                  _: 2
                }, 1032, ["visible"])
              ]),
              _: 1
            }, 8, ["uploaded_files", "model_files", "to_delete"])
          ], 512), [
            [_vShow, _ctx.requiredAlbi]
          ])
        ]),
        _createElementVNode("div", _hoisted_60, [
          _cache[110] || (_cache[110] = _createElementVNode("div", { class: "pb-2 font-bold text-sm" }, "Note", -1)),
          _createElementVNode("div", _hoisted_61, [
            _createVNode(_component_NextEditor, {
              modelValue: _ctx.fornitore_model.note,
              "onUpdate:modelValue": _cache[66] || (_cache[66] = ($event: any) => ((_ctx.fornitore_model.note) = $event))
            }, null, 8, ["modelValue"])
          ])
        ]),
        _createElementVNode("div", _hoisted_62, [
          _createVNode(_component_NextButton, {
            variant: "primary",
            onClick: _ctx.save,
            class: "w-48 text-sm sm:block py-2 px-4 ml-3"
          }, {
            default: _withCtx(() => _cache[111] || (_cache[111] = [
              _createTextVNode("Salva "),
              _createElementVNode("i", { class: "spinner" }, null, -1)
            ])),
            _: 1
          }, 8, ["onClick"])
        ])
      ])
    ])
  ], 64))
}